import React, { Component } from 'react';
import NumberFormat from 'react-number-format';

class ClockCardCalculationTable extends Component {
  constructor(props){
    super(props)
    this.state = {
      baseSalary: 0,
      hourlyRate: 0,
      salaryByHour: 0,
      lateHourlyRate: 0,
      lateHourlyTotal: 0,
      lateTimeRate: 0,
      lateTimeTotal: 0,
      absentHourlyRate: 0,
      absentHourTotal: 0,
      absentTimeRate: 0,
      absentTimeTotal: 0,
      earlyLeaveHourlyRate: 0,
      earlyLeaveHourTotal: 0,
      earlyLeaveTimeRate: 0,
      earlyLeaveTimeTotal: 0,
      benefit: 0,
      tax: 0,
      otherAddition: 0,
      otherDeduction: 0,
      totalSalary: 0
    }
  }
  renderTotalSalary() {
    let total = (parseFloat(this.state.baseSalary) + parseFloat(this.state.salaryByHour)
                - parseFloat(this.state.lateHourlyTotal) - parseFloat(this.state.lateTimeTotal) - parseFloat(this.state.absentHourTotal)
                - parseFloat(this.state.absentTimeTotal) - parseFloat(this.state.earlyLeaveHourTotal) - parseFloat(this.state.earlyLeaveTimeTotal) 
                + parseFloat(this.state.benefit) - parseFloat(this.state.tax) + parseFloat(this.state.otherAddition) - parseFloat(this.state.otherDeduction)).toFixed(2);
    this.props.onFormChange(total);
    return total;
  }
  render(){
    const { statistics } = this.props;
    return(
      <div>
        <table style={{width:'100%', textAlign: 'center'}}>
          <tr>
            <th></th>
            <th style={{ textAlign: 'center' }}>{__('Hour/Count', 'teacherAttendance')}</th>
            <th></th>
            <th style={{ textAlign: 'center' }}>{__('Rate', 'teacherAttendance')}</th>
            <th></th>
            <th style={{ textAlign: 'center' }}>{__('Total', 'teacherAttendance')}</th>
          </tr>
          <tr>
            <th>{__('Base Salary', 'teacherAttendance')}</th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <NumberFormat
                value={this.state.baseSalary}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({baseSalary: value})
                  }else {
                    this.setState({baseSalary: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.baseSalary === 0){
                    this.setState({baseSalary:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.baseSalary === ''){
                    this.setState({baseSalary:0})
                  }
                }}
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>+</td></tr>
          <tr>
            <th>{__('Salary (By Hours)', 'teacherAttendance')}</th>
            <td>{ statistics.work_duration.toFixed(2) } h</td>
            <td>x</td>
            <td>                
              <NumberFormat
                value={this.state.hourlyRate}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({hourlyRate: value, salaryByHour: (value * parseFloat(statistics.work_duration.toFixed(2))).toFixed(2)})
                  }else {
                    this.setState({hourlyRate: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.hourlyRate === 0){
                    this.setState({hourlyRate:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.hourlyRate === ''){
                    this.setState({hourlyRate:0, salaryByHour:0})
                  }
                }}
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
            <td>=</td>
            <td>{this.state.salaryByHour}</td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Late Penalty (By Hours)', 'teacherAttendance')}</th>
            <td>{statistics.late_duration.toFixed(2)} h</td>
            <td>x</td>
            <td>
              <NumberFormat
                value={this.state.lateHourlyRate}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({lateHourlyRate: value, lateHourlyTotal: (value * parseFloat(statistics.late_duration.toFixed(2))).toFixed(2)})
                  }else {
                    this.setState({lateHourlyRate: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.lateHourlyRate === 0){
                    this.setState({lateHourlyRate:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.lateHourlyRate === ''){
                    this.setState({lateHourlyRate:0, lateHourlyTotal:0})
                  }
                }}   
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
            <td>=</td>
            <td>{this.state.lateHourlyTotal}</td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Late Penalty (By Counts)', 'teacherAttendance')}</th>
            <td>{statistics.late_amount}</td>
            <td>x</td>
            <td>
              <NumberFormat
                value={this.state.lateTimeRate}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({lateTimeRate: value, lateTimeTotal: (value * statistics.late_amount).toFixed(2)})
                  }else {
                    this.setState({lateTimeRate: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.lateTimeRate === 0){
                    this.setState({lateTimeRate:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.lateTimeRate === ''){
                    this.setState({lateTimeRate:0, lateTimeTotal:0})
                  }
                }}  
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
            <td>=</td>
            <td>{this.state.lateTimeTotal}</td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Absent Penalty (By Hours)', 'teacherAttendance')}</th>
            <td>{statistics.absent_duration.toFixed(2)} h</td>
            <td>x</td>
            <td>
              <NumberFormat
                value={this.state.absentHourlyRate}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({absentHourlyRate: value, absentHourTotal: (value * parseFloat(statistics.absent_duration.toFixed(2))).toFixed(2)})
                  }else {
                    this.setState({absentHourlyRate: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.absentHourlyRate === 0){
                    this.setState({absentHourlyRate:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.absentHourlyRate === ''){
                    this.setState({absentHourlyRate:0, absentHourTotal:0})
                  }
                }} 
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
            <td>=</td>
            <td>{this.state.absentHourTotal}</td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Absent Penalty (By Counts)', 'teacherAttendance')}</th>
            <td>{statistics.absent_amount}</td>
            <td>x</td>
            <td>
              <NumberFormat
                value={this.state.absentTimeRate}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({absentTimeRate: value, absentTimeTotal: (value * statistics.absent_amount).toFixed(2)})
                  }else {
                    this.setState({absentTimeRate: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.absentTimeRate === 0){
                    this.setState({absentTimeRate:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.absentTimeRate === ''){
                    this.setState({absentTimeRate:0, absentTimeTotal:0})
                  }
                }} 
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
            <td>=</td>
            <td>{this.state.absentTimeTotal}</td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Leave Early Penalty (By Hours)', 'teacherAttendance')}</th>
            <td>{statistics.leave_early_duration.toFixed(2)} h</td>
            <td>x</td>
            <td>
              <NumberFormat
                value={this.state.earlyLeaveHourlyRate}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({earlyLeaveHourlyRate: value, earlyLeaveHourTotal: (value * parseFloat(statistics.leave_early_duration.toFixed(2))).toFixed(2)})
                  }else {
                    this.setState({earlyLeaveHourlyRate: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.earlyLeaveHourlyRate === 0){
                    this.setState({earlyLeaveHourlyRate:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.earlyLeaveHourlyRate === ''){
                    this.setState({earlyLeaveHourlyRate:0, earlyLeaveHourTotal:0})
                  }
                }} 
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
            <td>=</td>
            <td>{this.state.earlyLeaveHourTotal}</td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Leave Early Penalty (By Counts)', 'teacherAttendance')}</th>
            <td>{statistics.leave_early_amount}</td>
            <td>x</td>
            <td>
              <NumberFormat
                value={this.state.earlyLeaveTimeRate}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({earlyLeaveTimeRate: value, earlyLeaveTimeTotal: (value * statistics.leave_early_amount).toFixed(2)})
                  }else {
                    this.setState({earlyLeaveTimeRate: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.earlyLeaveTimeRate === 0){
                    this.setState({earlyLeaveTimeRate:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.earlyLeaveTimeRate === ''){
                    this.setState({earlyLeaveTimeRate:0, earlyLeaveTimeTotal:0})
                  }
                }} 
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
            <td>=</td>
            <td>{this.state.earlyLeaveTimeTotal}</td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>+</td></tr>
          <tr>
            <th>{__('Benefit', 'teacherAttendance')}</th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <NumberFormat
                value={this.state.benefit}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({benefit: value})
                  }else {
                    this.setState({benefit: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.benefit === 0){
                    this.setState({benefit:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.benefit === ''){
                    this.setState({benefit:0})
                  }
                }}
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Tax', 'teacherAttendance')}</th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <NumberFormat
                value={this.state.tax}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '');
                  if(value){
                    this.setState({tax: value})
                  }else {
                    this.setState({tax: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.tax === 0){
                    this.setState({tax:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.tax === ''){
                    this.setState({tax:0})
                  }
                }}
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>+</td></tr>
          <tr>
            <th>{__('Other Additions', 'teacherAttendance')}</th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <NumberFormat
                value={this.state.otherAddition}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '0');
                  if(value){
                    this.setState({otherAddition: value})
                  } else {
                    this.setState({otherAddition: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.otherAddition === 0){
                    this.setState({otherAddition:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.otherAddition === ''){
                    this.setState({otherAddition:0})
                  }
                }}
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
          </tr>
          <tr><td></td><td></td><td></td><td></td><td></td><td>-</td></tr>
          <tr>
            <th>{__('Other Deductions', 'teacherAttendance')}</th>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <NumberFormat
                value={this.state.otherDeduction}
                allowNegative={false}
                onChange={(event)=>{
                  let value = event.target.value.replace(/^0+/, '');
                  if(value){
                    this.setState({otherDeduction: value})
                  }else {
                    this.setState({otherDeduction: ''})
                  }
                }}
                onFocus={()=>{
                  if(this.state.otherDeduction === 0){
                    this.setState({otherDeduction:''})
                  }
                }}
                onBlur={()=>{
                  if(this.state.otherDeduction === ''){
                    this.setState({otherDeduction:0})
                  }
                }} 
                required={false}
                decimalScale={2}
                thousandSeparator={false}
                className='number-input'
              />
            </td>
          </tr>
          <tr><th></th><td></td><td></td><td></td><td></td><td>=</td></tr>
        </table>
        <div style={{ textAlign:'right', width: '100%', paddingRight:20 }}>{__('Total Salary:', 'teacherAttendance')} <span style={{ color: '#FCAF3D', fontSize: 18 }}>${this.renderTotalSalary()}</span></div>
      </div>
    )
  }
}

export default ClockCardCalculationTable;


// WEBPACK FOOTER //
// ./src/template/Modals/Salary/tables/clockCardCalculationTable.js